import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { backend_url } from "../../../App";

// Async thunk to fetch stats
export const fetchStats = createAsyncThunk(
  "stats/fetchStats",
  async (_, { getState, rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        return rejectWithValue("No authentication token found");
      }

      const config = {
        headers: {
          Authorization: `Token ${token}`,
        },
      };

      // Get current filters from store
      const state = getState();
      const filters = state.filters || {};

      // Build filter parameters
      let filterParams = "";
      if (filters.cameras && filters.cameras.length > 0) {
        filterParams += `&cameras=${filters.cameras.join(",")}`;
      }
      if (filters.species && filters.species.length > 0) {
        filterParams += `&species=${filters.species.join(",")}`;
      }
      if (filters.range && filters.range.startDate) {
        const startDate = filters.range.startDate.split("T")[0];
        filterParams += `&date_gte=${startDate}`;
      }
      if (filters.range && filters.range.endDate) {
        const endDate = filters.range.endDate.split("T")[0];
        filterParams += `&date_lte=${endDate}`;
      }

      // Remove the leading & if filterParams is not empty
      if (filterParams.startsWith("&")) {
        filterParams = filterParams.substring(1);
      }

      // Build the URL with proper query parameter handling
      let url = `${backend_url}/core/api/events/stats-summary/`;
      if (filterParams) {
        url += `?${filterParams}`;
      }

      // Use the stats_summary endpoint from EventViewSet
      const response = await axios.get(url, config);

      return response.data;
    } catch (error) {
      console.error("Error fetching stats:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const statsSlice = createSlice({
  name: "stats",
  initialState: {
    stats: {
      cameras: 0,
      events: 0,
      species: 0,
      users: 0,
    },
    loading: false,
    error: null,
  },
  reducers: {
    resetStats: (state) => {
      state.stats = {
        cameras: 0,
        events: 0,
        species: 0,
        users: 0,
      };
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStats.fulfilled, (state, action) => {
        state.loading = false;
        state.stats = action.payload;
      })
      .addCase(fetchStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetStats } = statsSlice.actions;
export const selectStats = (state) => state.stats.stats;
export const selectStatsLoading = (state) => state.stats.loading;
export const selectStatsError = (state) => state.stats.error;

export default statsSlice.reducer;
